import React from "react";
import Padding from "../../shared/components/Padding";
import Spacer from "../../shared/components/Spacer";
import Close from "../../shared/components/Close";
import AdaptiveFlex from "../../features/common/components/AdaptiveFlex";
import useDevice from "../../shared/hooks/useDevice";

function ScrollModal({ headerText, size, modal, paddingX, paddingY, duration = "0.5", maxWidth}) {
    const device = useDevice();
    const isMobile = device !== "desktop";

    return (
        <div className={modal.open ? "openModal modal" : "modal"} style={{animation: `modal-bg-show ${duration}s`,WebkitAnimation: `modal-bg-show ${duration}s`}}>
            {modal.open ? (
                <div style={{width: isMobile ? "90%" : size, margin: 'auto', backgroundColor: "white", borderRadius: "20px", maxWidth: maxWidth}}>
                    <Padding paddingX={20} paddingY={20}>
                        <div style={{backgroundColor: "white", fontSize: "18px", fontWeight: "bold", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            {modal.headerText ? modal.headerText : headerText}
                            <Close size="md" onClick={modal.close} />
                        </div>
                    </Padding>
                    
                    <AdaptiveFlex flexDirection="column">
                        {modal.main}
                    </AdaptiveFlex>
                </div>
            ) : null}
        </div>
    );
}

export default ScrollModal;
